import React, { useState } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { Grid, Card, Typography, Button, Box, Divider } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import { getCookie, setCookie } from '../../hooks/useCookie';
import EirLoader from '../eir-loader/EirLoader';

const { publicRuntimeConfig } = getConfig();
const CrossSellPreCardInfo = ({
  info,
  cta,
  tvSelected = false,
  selectTariff,
  removeTariff,
  showLoader = false,
  selected,
  setSelected,
  createCSForECC,
  subscriptions,
  modalCmsData,
  setOpenSubscriptionSelectionModal,
}) => {
  const [selectedMobileCta, setSelectedMobileCta] = useState(false);
  const theme = useTheme();
  const router = useRouter();
  // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
  const addToCart = async (code, offerCode) => {
    if (subscriptions.length < 2) {
      await selectTariff(code, offerCode, 'CROSS_SELL');
    } else {
      setOpenSubscriptionSelectionModal(true);
      setCookie('CS', 'CODE', code);
      setCookie('CS', 'OFFER_CODE', offerCode);
    }
  };
  const removeFromCart = async code => {
    await removeTariff(code, 'CROSS_SELL');
  };
  const seePlans = async () => {
    setSelectedMobileCta(true);
    if (getCookie('cart_Type') !== 'CROSS_SELL') {
      await createCSForECC();
    }
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
  };
  React.useEffect(() => {
    if (tvSelected) setSelected(true);
    else setSelected(false);
  }, [tvSelected]);

  return (
    <>
      <Box
        sx={[
          styles(theme).contractTagContainer,
          info.contractPeriod === 0 && {
            background: 'none',
            mb: '-1.1rem',
            height: '2.6rem',
          },
          cta === 'nav'
            ? ''
            : {
                background: modalCmsData?.CSPreCards?.CSPreCard[0]?.ContractBackgroundColour,
              },
        ]}
      >
        <Typography
          variant='body1'
          sx={
            ([styles(theme).infoText1],
            {
              textAlign: 'center',

              color: modalCmsData?.CSPreCards?.CSPreCard[0]?.TVContractFontColour,
            })
          }
        >
          {info.contractPeriod > 0 && `${info?.contractPeriod} month contract`}
        </Typography>
      </Box>
      {/* } */}
      <Card
        sx={[
          info?.contractPeriod === 0
            ? { borderRadius: '10px 10px 10px 10px' }
            : { borderRadius: '0px 0px 10px 10px' },
          styles(theme).infoCard,
        ]}
      >
        <Grid container xs={12} sx={{ justifyContent: 'space-around', alignItems: 'center' }}>
          <Grid item xs={3} sm={3} md={3}>
            <Typography variant='h5' sx={styles(theme).infoText2}>
              {info?.title}
            </Typography>
            <Typography variant='body2' sx={styles(theme).infoText4}>
              {info?.subTitle}
            </Typography>
          </Grid>
          <Grid item>
            <Divider
              orientation='vertical'
              flexItem='true'
              variant='middle'
              sx={styles(theme).infoCardDivider}
            />
          </Grid>
          <Grid
            item
            xs={3}
            md={3}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Typography variant='caption' sx={styles(theme).infoText1}>
              {cta === 'nav' ? 'From' : 'Only'}
            </Typography>
            <Typography variant='h4' sx={styles(theme).infoText3}>
              {info?.price}
            </Typography>
            <Typography variant='caption' sx={styles(theme).infoText1}>
              a month
            </Typography>
          </Grid>
          {cta === 'add' && (
            <Grid item xs={4} sm={4}>
              {showLoader ? (
                <EirLoader loaderTitle={selected ? 'removing' : 'adding'} />
              ) : (
                <Button
                  variant='buttonMedium'
                  sx={{
                    ...styles(theme)?.infoCTA,
                    ...(selected ? styles(theme).infoCTASelected : {}),
                  }}
                  onClick={() => {
                    if (selected) removeFromCart(info.code);
                    else addToCart(info.code, info.offerCode);
                  }}
                  id={selected ? 'added' : 'removed'}
                >
                  {/* {!selected && (
                    <span style={{ fontSize: '1.2rem', fontWeight: 'normal' }}>+&nbsp;</span>
                  )} */}
                  {selected ? 'Added' : 'Add TV'}
                  {selected && (
                    <CheckCircleOutlineOutlinedIcon sx={styles(theme).addonMobileCtaCheck} />
                  )}
                </Button>
              )}
            </Grid>
          )}
          {cta === 'nav' && (
            <Grid item xs={4} sm={4}>
              <Button
                variant='buttonMedium'
                sx={{
                  ...styles(theme).infoCTA2,
                  ...(selectedMobileCta ? styles(theme).infoCTASelected : {}),
                }}
                // variant='outlined'
                onClick={() => {
                  seePlans();
                }}
              >
                See plans
              </Button>
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );
};

export default CrossSellPreCardInfo;
